export default __webpack_public_path__ + "static/serviceDetails-7a242c328447c9f83bb9ff585dcb6d4b.jpeg";